import { Palette, BarChart3, Zap, Globe, ShieldCheck, Layers } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
  {
    icon: Palette,
    title: "Design without limits",
    body: "Fully themeable pages with your fonts, colors and motion. Light or dark — your brand, pixel-perfect.",
    span: "lg:col-span-7",
    big: true,
  },
  {
    icon: BarChart3,
    title: "Analytics that matter",
    body: "Real-time clicks, sources and conversions.",
    span: "lg:col-span-5",
  },
  {
    icon: Zap,
    title: "Blocks for everything",
    body: "Spotify, YouTube, bookings, products, forms.",
    span: "lg:col-span-5",
  },
  {
    icon: Globe,
    title: "Own your domain",
    body: "Connect a custom domain in a couple of clicks and keep every visitor on-brand.",
    span: "lg:col-span-7",
    big: true,
  },
  {
    icon: ShieldCheck,
    title: "Privacy first",
    body: "GDPR-ready, cookieless analytics.",
    span: "lg:col-span-4",
  },
  {
    icon: Layers,
    title: "One system, everywhere",
    body: "Landing, profile and dashboard share a single design language.",
    span: "lg:col-span-8",
  },
];

export const Features = () => (
  <section id="features" data-testid="features" className="px-6 py-28 md:px-12 lg:px-24">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-inkMuted">The toolkit</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold tracking-tighter text-ink md:text-5xl lg:text-6xl">
          Everything your audience needs, in one link
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-12">
        {FEATURES.map((f, i) => (
          <Reveal key={f.title} delay={(i % 3) * 0.08} className={f.span}>
            <div className="group h-full rounded-3xl border border-line bg-surface p-7 shadow-soft transition-transform duration-300 hover:-translate-y-1">
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-lime text-limeText">
                <f.icon size={22} />
              </span>
              <h3 className={`mt-6 font-display font-semibold tracking-tight text-ink ${f.big ? "text-2xl md:text-3xl" : "text-xl"}`}>
                {f.title}
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-inkMuted md:text-base">{f.body}</p>
              <span className="mt-6 block h-[2px] w-0 bg-lime transition-all duration-300 group-hover:w-16" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
